// extracted by mini-css-extract-plugin
module.exports = {"option-container":"ProjectOptions_option-container__2MlNY","data-fetching":"ProjectOptions_data-fetching__1gHPT"};